<template>
  <v-col class="d-flex flex-column text-center">
    <v-img contain :src="item.image_path" class="mb-10" style="max-height: 400px" />
    <div class="text-tcdc-green sub-header1 bold mb-3">{{item.header}}</div>
    <div class="mb-3" style="height: 125px;">{{item.content}}</div>
    <div class="text-center">
      <GreenButton :label="$t('our-service.readmore')" @click.native="eventClick" />
    </div>
  </v-col>
</template>

<script>
import GreenButton from "../buttons/GreenButton";
export default {
  components: {
    GreenButton
  },
  props: {
    item: {
      required: true
    }
  },
  methods: {
    eventClick() {
      this.$emit('onPress');
    }
  }
};
</script>

<style scoped>

</style>
